var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
import "pixi.js";
import { merge, Subject } from "rxjs";
import { map, withLatestFrom } from "rxjs/operators";
import { IdTooltipsDelay } from "../../../constants/IdTooltipsDelay";
import { IdTooltipType } from "../../../constants/IdTooltipType";
import { eventsCanvas } from "../../../events/eventsCanvas";
import { GetBuildingFinishedScaffoldingIso } from "../../../graphics/GetBuildingFinishedScaffoldingIso";
import { GetBuildingGraphicIso } from "../../../graphics/GetBuildingGraphicIso";
import { getBuildingIsoVolume } from "../../../graphics/getBuildingIsoVolume";
import { GetBuildingScaffoldingIso } from "../../../graphics/GetBuildingScaffoldingIso";
import { selectDiscountedBuildingIds } from "../../../selectors/selectDiscountEvent";
import { selectAllExistingBuildingInfo } from "../../../selectors/selectExistingBuildingInfo";
import { debugGetBuildingHighlightIso } from "../../../utils/graphics/debugGraphics";
import { utilGrid } from "../../../utils/grid/utilGrid";
import { shallowDiffers } from "../../../utils/shallowDiffers";
import { IdEventSoundCore } from "../../../utils/sound/IdEventSoundCore";
import { utilSound } from "../../../utils/sound/utilSound";
import { utilBuildings } from "../../../utils/utilBuildings";
import { ShopCategoryType } from "../../balancing/types/BalancingCore";
import { SceneLayer } from "../../scenes/SceneLayer";
import { actionTooltipHideBuildingText, actionTooltipShowBuildingText, } from "../../tooltip/actionTooltip";
import { actionBuildingsPreSelect } from "../buildings/actionBuildings";
import { IsoBuilding } from "../buildings/IsoBuilding";
import { TypeBuildingAction } from "../buildings/reducerBuildings";
var Point = PIXI.Point;
var LayerPlayerBaseBuildings = /** @class */ (function (_super) {
    __extends(LayerPlayerBaseBuildings, _super);
    function LayerPlayerBaseBuildings() {
        var _this = _super.call(this) || this;
        _this.update$ = new Subject();
        _this.drawnBuildingInfoById = new Map();
        _this.buildingDataById = new Map();
        _this.dispatched = false;
        _this.shouldUpdate = function (state, previousState) {
            return (!previousState ||
                state.buildingPlacement !== previousState.buildingPlacement ||
                state.playerBase.buildings.building !== previousState.playerBase.buildings.building ||
                state.buildings.length !== previousState.buildings.length ||
                state.buildings.some(function (building, index) {
                    return shallowDiffers(building.proto, previousState.buildings[index].proto) ||
                        shallowDiffers(building.production, previousState.buildings[index].production);
                }) ||
                state.animationEnabled !== previousState.animationEnabled);
        };
        _this.update = function (props) {
            var buildingPlacement = props.buildingPlacement, buildings = props.buildings, discountedBuildingIds = props.discountedBuildingIds, playerBase = props.playerBase, animationEnabled = props.animationEnabled;
            var selected = buildingPlacement.action === TypeBuildingAction.Select;
            var showGrid = buildingPlacement.action === TypeBuildingAction.Move ||
                buildingPlacement.action === TypeBuildingAction.Unstore ||
                buildingPlacement.action === TypeBuildingAction.Construct;
            _this.buildingDataById.clear();
            var updated = buildings
                .filter(function (building) { return building.balancing.shopCategory !== ShopCategoryType.Fence; })
                .map(function (building) {
                return _this.updateBuilding({
                    animationEnabled: animationEnabled,
                    building: building,
                    getBuildingFinishedScaffoldingIso: GetBuildingFinishedScaffoldingIso,
                    getBuildingGraphicIso: GetBuildingGraphicIso,
                    getBuildingHighlightIso: debugGetBuildingHighlightIso,
                    getBuildingIsoVolume: getBuildingIsoVolume,
                    getBuildingScaffoldingIso: GetBuildingScaffoldingIso,
                    isDiscounted: discountedBuildingIds.some(function (buildingId) { return buildingId === building.balancing.id; }),
                    selected: selected,
                    showGrid: showGrid,
                });
            })
                .some(function (wasUpdated) { return wasUpdated; });
            var removed = _this.removeOldBuildings(buildings);
            var selectedBuildingUpdated = playerBase.buildings.building !== _this.selectedBuilding &&
                playerBase.buildings.building !== undefined;
            _this.updateSelectedBuildingHighlight(props);
            _this.selectedBuilding = playerBase.buildings.building;
            if (selectedBuildingUpdated || updated || removed) {
                if (_this.mouseOverSub) {
                    _this.mouseOverSub.unsubscribe();
                    _this.mouseOutSub.unsubscribe();
                    _this.mouseClickSub.unsubscribe();
                }
                var overs_1 = [];
                var outs_1 = [];
                var clicks_1 = [];
                _this.drawnBuildingInfoById.forEach(function (building) {
                    var over$ = eventsCanvas.createMouseOver$(building).pipe(map(function (event) { return ({
                        building: building,
                        data: event.data,
                    }); }));
                    var out$ = eventsCanvas.createMouseOut$(building).pipe(withLatestFrom(over$));
                    var click$ = eventsCanvas.createClick$(building);
                    clicks_1.push(click$);
                    overs_1.push(over$);
                    outs_1.push(out$);
                });
                _this.mouseOverSub = merge.apply(void 0, overs_1).subscribe(function (data) { return _this.onMouseOver(data, props); });
                _this.mouseOutSub = merge.apply(void 0, outs_1).subscribe(_this.onMouseOut);
                _this.mouseClickSub = merge.apply(void 0, clicks_1).subscribe(_this.createOnClick(props));
                // To not cause re-sort when only selected building is updated
                if (!selectedBuildingUpdated && _this.shouldIsoSort) {
                    _this.update$.next(true);
                }
                _this.shouldIsoSort = false;
            }
        };
        _this.mapState = function (state) { return ({
            animationEnabled: state.playerSettingsInfo.animationEnabled,
            buildingPlacement: state.playerBase.buildings,
            buildings: selectAllExistingBuildingInfo(state),
            deps: state.dependencies,
            discountedBuildingIds: selectDiscountedBuildingIds(state),
            playerBase: state.playerBase,
        }); };
        _this.mapDispatch = function (dispatch) { return ({
            onMouseOutDispatch: function (id) { return dispatch(actionTooltipHideBuildingText(id)); },
            onMouseOverDispatch: function (id, position, loca, stage) {
                return dispatch(actionTooltipShowBuildingText(id, position, loca, stage));
            },
            onSelect: function (building, pos) {
                dispatch(actionBuildingsPreSelect(building, pos));
            },
        }); };
        _this.dispose = function () {
            _this.mouseOverSub.unsubscribe();
            _this.mouseOutSub.unsubscribe();
            _this.mouseClickSub.unsubscribe();
            return _this;
        };
        _this.getIsoObject = function (obj) {
            var building = _this.buildingDataById.get(obj.buildingId);
            var buildingDisplay = _this.drawnBuildingInfoById.get(obj.buildingId);
            var isoObj = utilBuildings.buildingDataToGridObject(building);
            return __assign({}, isoObj, { display: obj, volume: buildingDisplay.volume });
        };
        _this.getObjects = function () { return Array.from(_this.drawnBuildingInfoById.values()); };
        _this.updateSelectedBuildingHighlight = function (props) {
            var _a = props.playerBase.buildings, action = _a.action, building = _a.building;
            if (action !== TypeBuildingAction.None && building != undefined) {
                var isoBuilding = _this.drawnBuildingInfoById.get(building.proto.id);
                if (isoBuilding != undefined) {
                    isoBuilding.showHighlight();
                }
            }
            else if (_this.selectedBuilding != undefined) {
                var isoBuilding = _this.drawnBuildingInfoById.get(_this.selectedBuilding.proto.id);
                if (isoBuilding != undefined) {
                    isoBuilding.hideHighlight();
                }
            }
        };
        _this.createOnClick = function (props) { return function (event) {
            if (!(event.currentTarget instanceof IsoBuilding)) {
                return;
            }
            var action = props.buildingPlacement.action;
            if (action === TypeBuildingAction.Move || action === TypeBuildingAction.Construct) {
                return;
            }
            var buildingId = event.currentTarget.buildingId;
            var building = props.buildings.find(function (value) { return value.proto.id === buildingId; });
            if (building != undefined) {
                var center = utilGrid.objectCenterOnScreen(utilBuildings.buildingDataToGridObject(building));
                var pos = _this.toGlobal(new Point(center.x, center.y));
                props.onSelect(building, pos);
                utilSound.event(IdEventSoundCore.ButtonClick);
            }
            else {
                throw new Error("Selected a building which doesn't exist. Building ID " + buildingId);
            }
        }; };
        _this.onMouseOver = function (data, props) {
            var id = data.building.buildingId;
            var buildingData = _this.buildingDataById.get(id);
            var gridObj = __assign({}, utilBuildings.buildingDataToGridObject(buildingData), { volume: Math.max(buildingData.balancing.xExtent, buildingData.balancing.yExtent) });
            var pointToTranslate = utilGrid.objectCenterOnScreenGlobal(gridObj);
            var position = new PIXI.Point(pointToTranslate.x, pointToTranslate.y);
            if (props.buildingPlacement.action !== TypeBuildingAction.Move) {
                data.building.showHighlight();
            }
            if (!_this.dispatched && !utilBuildings.hasFinishedConstruction(buildingData)) {
                clearTimeout(_this.mouseOverSubTimer);
                _this.mouseOverSubTimer = setTimeout(function () {
                    _this.dispatched = true;
                    _this.props.onMouseOverDispatch(IdTooltipType.BaseBuilding + id, position, buildingData.balancing.locaKey, buildingData.proto.stage);
                }, IdTooltipsDelay.standardDelay);
            }
        };
        _this.onMouseOut = function (data) {
            var isoBuilding = data[1].building;
            if (!_this.selectedBuilding || _this.selectedBuilding.proto.id !== isoBuilding.buildingId) {
                isoBuilding.hideHighlight();
                clearTimeout(_this.mouseOverSubTimer);
                if (_this.dispatched) {
                    _this.dispatched = false;
                    _this.props.onMouseOutDispatch(IdTooltipType.BaseBuilding + data[1].building.buildingId);
                }
            }
        };
        _this.removeOldBuildings = function (buildings) {
            var removed = false;
            _this.drawnBuildingInfoById.forEach(function (info, key) {
                if (!buildings.find(function (data) { return data.proto.id === key; })) {
                    _this.removeBuilding(key);
                    removed = true;
                }
            });
            return removed;
        };
        _this.removeBuilding = function (id) {
            var building = _this.drawnBuildingInfoById.get(id);
            if (building != undefined) {
                building.dispose();
                _this.cleanupChild(building);
                _this.drawnBuildingInfoById.delete(id);
                return true;
            }
            return false;
        };
        _this.updateBuilding = function (isoBuildingProps) {
            var proto = isoBuildingProps.building.proto;
            _this.buildingDataById.set(proto.id, isoBuildingProps.building);
            var buildingId = proto.id;
            var display = _this.drawnBuildingInfoById.get(buildingId) || new IsoBuilding();
            var needsUpdate = display.update(isoBuildingProps);
            var needsIsoSort = display.requiresIsoSort();
            _this.shouldIsoSort = _this.shouldIsoSort || needsIsoSort;
            display.hideHighlight();
            _this.drawnBuildingInfoById.set(buildingId, display);
            var pos = utilGrid.mapToScreen(proto.posX, proto.posY);
            if (display.position.x !== pos.x || display.position.y !== pos.y) {
                display.position.set(pos.x, pos.y);
                needsUpdate = true;
            }
            return needsUpdate;
        };
        _this.interactive = true;
        return _this;
    }
    return LayerPlayerBaseBuildings;
}(SceneLayer));
export { LayerPlayerBaseBuildings };



//////////////////
// WEBPACK FOOTER
// ./src/features/player-base/layers/LayerPlayerBaseBuildings.ts
// module id = 2204
// module chunks = 3